import { useEffect, useState } from 'react';
import styles from './DailyActivitiesInformation.module.scss';
import {
   Box,
   Dialog,
   DialogActions,
   DialogContent,
   DialogContentText,
   DialogTitle,
   IconButton,
   Typography,
} from '@mui/material';
import tablestyles from '../../devoteeService/devoteeService.module.scss';
import DailyActivitiesForm from './DilayActivitiesForm';
import updateIcon from '../../../assets/svg/update_outline.svg';
import deleteIcon from '../../../assets/svg/delete_outline.svg';
import commonStyles from '../../../App.module.scss';
import Pagination from '../../common/pagination/pagination';
import { CommonButton, CommonOutlinedButton } from '../../common/StyledComponents/StyledFields';
import CloseIcon from '@mui/icons-material/Close';
import { apiRequest, catchErrorMessageHandler } from '../../../infrastructure/backendService';
import SuccessPopup from '../../devotee/donation/successPopup';
import toast from 'react-hot-toast';
import LOCALE from '../../../config/en-us.json';
import constants from '../../../config/constants.json';
import ErrorPopup from '../../common/ErrorPopup';
import ToastSuccess from '../../common/toast/toastSuccess';
import apiPath from '../../../config/apiPaths.json';

interface DailyActivityProps {
   activityTableList?: never[];
   setActivityTableList?: React.Dispatch<React.SetStateAction<never[]>>;
   pageNumber?: number;
   setPageNumber?: React.Dispatch<React.SetStateAction<number>>;
   totalRecords?: number;
   setIsEditFormOpen?: React.Dispatch<React.SetStateAction<boolean>>;
   showMessage?:any;
}
interface Activity {
   id: string; // Adjust the type of id property according to your actual data
}

const DailyActivityInformation = (props: DailyActivityProps): JSX.Element => {
   const [showForm, setShowForm] = useState(false);
   const [closeForm, setCloseForm] = useState(false);
   const [selectedId, setSelectedId] = useState<any | null | undefined>(null);
   const [selectData, setSelectData] = useState<any>([]);
   const [selectedSpecialId, setSelectedActivityId] = useState<any | null | undefined>(null);
   const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
   const [isOpen, setIsOpen] = useState<boolean>(false);

   const openConfirmPopUp1 = (id: number | undefined | null) => {
      setSelectedActivityId(id);
      setIsOpenDialog(true);
   };
   const handleClose = () => {
      setIsOpen(false);
      setIsOpenDialog(false);
      setSelectedId(null);
      setSelectedActivityId(null);
   };
   const handleDeleteDailyActivities = () => {
      deleteDailyActivityApiCall();
   };

   const deleteDailyActivityApiCall = () => {
      apiRequest({
         method: 'DELETE',
         endpoint: `${apiPath.addedTempleActivity}/${selectedSpecialId}`,
         includeToken: true,
      })
         .then((res) => {
            const successMessage = LOCALE.SPECELEVENTS_DELETED;
            toast.custom(<ToastSuccess message={successMessage} sent={''} />, {
               duration: 10000,
            });
            toast.custom(
               <SuccessPopup
                  headerMessage="User Events"
                  showMessage={successMessage}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
               />,
               {
                  duration: constants.TOAST_POPUP_DURATION,
               },
            );
         })
         .catch((err) => {
            toast.custom(
               <ErrorPopup
                  showMessage={catchErrorMessageHandler(err)}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
               />,
               {
                  duration: constants.TOAST_POPUP_DURATION,
               },
            );
         });
   };
   const handleAgree = () => {
      if (selectedSpecialId !== null && props.activityTableList && props.setActivityTableList) {
         // Find the index of the item with the selected ID in the addedItemsList
         const indexToRemove = props.activityTableList.findIndex(
            (item: Activity) => item.id === selectedSpecialId,
         );

         handleDeleteDailyActivities();
         if (indexToRemove !== -1) {
            // Create a copy of the addedItemsList without the selected item
            const updatedList = [...props.activityTableList];
            updatedList.splice(indexToRemove, 1);
            // Update the addedItemsList and recalculate the total donation amount
            props.setActivityTableList(updatedList);
         }
      }
      // Close the dialog
      handleClose();
   };
   const handleGetActivityData = (data: any) => {
      setSelectData(data);
      setSelectedActivityId(data?.id);
      setShowForm(true);
      props?.setIsEditFormOpen?.(true);
   };
   const dialogPopup = () => {
      return (
         <Dialog
            open={isOpenDialog}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
               style: {
                  height: 'calc(100% - 128px)',
                  width: 'calc(100% - 128px)',
                  margin: '64px',
                  maxWidth: '504px',
                  maxHeight: '180px',
                  overflowY: 'unset',
                  borderTopLeftRadius: '16px',
                  borderTopRightRadius: '16px',
               },
            }}
         >
            <DialogTitle className={commonStyles.dialogTitle}>
               {'Please Confirm'}

               <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={{
                     position: 'absolute',
                     right: 24,
                     top: 12,
                     color: (theme: any) => theme.palette.grey[500],
                  }}
               >
                  <CloseIcon sx={{ color: 'white' }} />
               </IconButton>
            </DialogTitle>
            <DialogContent>
               <DialogContentText
                  id="alert-dialog-slide-description"
                  className={commonStyles.dialogContext}
               >
                  Are You Sure want to remove the Daily Activity?
               </DialogContentText>
            </DialogContent>

            <DialogActions>
               <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
               <CommonButton onClick={handleAgree}>Yes</CommonButton>
            </DialogActions>
         </Dialog>
      );
   };
   useEffect(() => {
      if (closeForm) {
         setShowForm(false);
         props?.setIsEditFormOpen?.(false);
      }
   }, [closeForm]);
   const DailyActivitiesTable = () => {
      return (
         <>
            <div style={{ overflowY: 'auto', padding: '15px' }}>
               {showForm ? (
                  <DailyActivitiesForm selectedData={selectData} setCloseForm={setCloseForm} />
               ) : (
                  <div>
                     {props.activityTableList && props.activityTableList.length > 0 ? (
                        <table
                           className={tablestyles.tableContainer}
                           style={{ boxShadow: '0px 2px 20px rgba(236.8, 236.8, 236.8, 0.8);' }}
                        >
                           <thead>
                              <tr className={tablestyles.headerTableRow}>
                                 <th className={tablestyles.tableHorizontal}>Activity Name</th>
                                 <th className={tablestyles.tableHorizontal}>Schedule Date</th>
                                 <th className={tablestyles.tableHorizontal}>Schedule Time</th>
                                 <th className={tablestyles.tableHorizontal}>Action</th>
                              </tr>
                           </thead>
                           <tbody className={tablestyles.tableBody} id="searchData">
                              {props.activityTableList.map((row: any, index: number) => (
                                 <tr key={row.id} className={tablestyles.tableRow}>
                                    <td
                                       className={tablestyles.tableDiagonal}
                                       style={{
                                          color: '#000',
                                          fontWeight: 400,
                                          textAlign: 'start',
                                       }}
                                    >
                                       {row.activityName}
                                    </td>
                                    <td
                                       className={tablestyles.tableDiagonal}
                                       style={{
                                          color: '#000',
                                          fontWeight: 400,
                                          textAlign: 'start',
                                       }}
                                    >
                                       {row.scheduleDate}
                                    </td>
                                    <td
                                       className={tablestyles.tableDiagonal}
                                       style={{
                                          fontWeight: 400,
                                          color: '#000',
                                          textAlign: 'start',
                                       }}
                                    >
                                       {row.activityStartTime}
                                    </td>
                                    <td
                                       className={styles.tableDiagonal}
                                       style={{ textAlign: 'center', cursor: 'pointer' }}
                                    >
                                       <img
                                          src={updateIcon}
                                          onClick={() => handleGetActivityData(row)}
                                       />
                                       <img
                                          src={deleteIcon}
                                          onClick={() => openConfirmPopUp1(row?.id)}
                                       />
                                    </td>
                                 </tr>
                              ))}
                           </tbody>
                        </table>
                     ) : (
                        <Typography sx={{ margin: '24px auto', color: 'red', fontSize: '28px' }}>
                           <b>{props?.showMessage ? " No Activities Found" :"" }</b>
                        </Typography>
                     )}
                     {props?.totalRecords &&
                     props?.totalRecords > 20 &&
                     props?.setPageNumber &&
                     props?.pageNumber ? (
                        <div
                           style={{
                              display: 'flex',
                              justifyContent: 'end',
                              marginRight: '10px',
                              marginTop: '3px',
                           }}
                        >
                           <Pagination
                              items={props?.totalRecords}
                              itemsPerPage={20}
                              setPageNumber={props?.setPageNumber}
                              pageNumber={props?.pageNumber}
                           />
                        </div>
                     ) : (
                        ''
                     )}
                  </div>
               )}
            </div>
         </>
      );
   };

   return (
      <>
         <Box className={styles.formLayout}>{DailyActivitiesTable()}</Box>
         {dialogPopup()}
      </>
   );
};

export default DailyActivityInformation;
